import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const state = {
  isUploading: false,
  meta: {}
}

const actions = {
  fetchReport({ commit }, { config, customUrlFnArgs = [] }) {
    const url = '/workers/documents';
    commit('fetchListStart');
    
    return api.client.get(url, config)
      .then(res => {
        commit('fetchListSuccess', res.data);
        return res.data;
      })
      .catch(err => {
        console.log(err)
        commit('fetchListError', err.response.data);
        return Promise.reject(err.response.data);
      })
  }
}

const mutations = {
  setUploading: (state, status) => {
    state.isUploading = !!status;
  }
}

export default createCrudModule({
  client: api.client,
  resource: 'documents',
  parseList: res => res.data,
  parseSingle: res => res.data,
  onFetchListSuccess: (state, { meta }) => {
    if (meta) state.meta = meta;
  },
  customUrlFn: (id, params) => `/workers/${params.worker_id}/documents${id ? '/'+id : ''}`,
  state,
  actions,
  mutations
});